import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../antd/card/CardTitle";
import { CardContent } from "../antd/card/CardContent";
import { Table } from "../../newcomponents/table/table";
import { NameValuePair, Tags } from "../../schema/types/base";
import { tagsToInput } from "../../mst/kinds/utils";

interface Props {
  tags: Tags;
}
export const TagsReadonly: React.FC<Props> = ({ tags }) => {
  const tagsData = tagsToInput(tags);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>Tags</CardTitle>
          <CardContent collapsed={false}>
            <Table<NameValuePair>
              tableId="form-tags-update1"
              styles={{ header: { margin: 0 } }}
              data={tagsData}
              hideSettings
              columns={[
                { id: "name", label: "Key", enableResize: true, size: 200 },
                { id: "value", label: "Value", enableResize: true, size: 200 },
              ]}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
};
